module.exports = __webpack_public_path__ + "img/spreedly-integration.ea4371c8.png";